import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home/index_page";
import About from "./components/About/about";
import Team from "./components/Team/Team";
import Contact from "./components/Contact/Contact";
import Courses from "./components/Courses/Courses";
import C from "./components/Courses/Course_info/C";
import Cpp from "./components/Courses/Course_info/CPP";
import JAVA from "./components/Courses/Course_info/JAVA";
import DotNet from "./components/Courses/Course_info/DotNet";
import PHP from "./components/Courses/Course_info/PHP";
import Python from "./components/Courses/Course_info/PYTHON";
import ReactJS from "./components/Courses/Course_info/REACTJS";
import ReactNative from "./components/Courses/Course_info/REACTNATIVE";
import NodeJS from "./components/Courses/Course_info/NODEJS";
import Android from "./components/Courses/Course_info/ANDROID";
import DataBase from "./components/Courses/Course_info/DATABASE";
import WebDesigning from "./components/Courses/Course_info/WebDesigning";
import WebProgramming from "./components/Courses/Course_info/WebProgramming";
export default function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route exact path="/About" element={<About />} />
          <Route exact path="/Team" element={<Team />} />
          <Route exact path="/Contact" element={<Contact />} />
          <Route exact path="/Courses" element={<Courses />} />
          <Route exact path="/C" element={<C/>} />
          <Route exact path="/CPP" element={<Cpp/>} />
          <Route exact path="/JAVA" element={<JAVA/>} />
          <Route exact path="/DotNet" element={<DotNet/>} />
          <Route exact path="/PHP" element={<PHP/>} />
          <Route exact path="/PYTHON" element={<Python/>} />
          <Route exact path="/ReactJS" element={<ReactJS/>} />
          <Route exact path="/ReactNative" element={<ReactNative/>} />
          <Route exact path="/NodeJS" element={<NodeJS/>} />
          <Route exact path="/ANDROID" element={<Android/>} />
          <Route exact path="/DATABASE" element={<DataBase/>} />
          <Route exact path="/WebDesigning" element={<WebDesigning/>} />
          <Route exact path="/WebProgramming" element={<WebProgramming/>} />
        </Routes>
      </Router>
    </>
  );
}
